/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { ApiErrorDetails } from './apiErrorDetails';

/**
 * Standard error response structure for GenericApiResponse

The error code should be one of the ErrorCatalog class variables or its subclasses.
This ensures consistent error codes across the application while allowing
domain-specific error codes.

Example:
    ApiError(
        code=SubmissionErrors.NOT_SUBMITTED.code,
        message="Module must be submitted first",
        details={"state": "draft"}
    )
 */
export interface ApiError {
  code: string;
  message: string;
  details?: ApiErrorDetails;
}
